import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { readinessApi } from '@/api/readiness';

export const READINESS_CHECKLIST_QUERY_KEY = ['readiness-checklist'] as const;

export function useReadinessChecklist() {
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: READINESS_CHECKLIST_QUERY_KEY,
        queryFn: readinessApi.get,
        staleTime: 15_000,
    });

    const completionMutation = useMutation({
        mutationFn: readinessApi.complete,
        onSuccess: (checklist) => {
            queryClient.setQueryData(READINESS_CHECKLIST_QUERY_KEY, checklist);
        },
    });

    return {
        checklist: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
        markCompleted: completionMutation.mutateAsync,
        isMarkingComplete: completionMutation.isPending,
    };
}
